import { Period } from '../context/PeriodProvider';
import { fetchAndParse } from '../lib/utils';
import { ClientConfig } from '../types/ClientConfig';
import { Role } from '../types/Role';
import { BaseClient, Endpoints, getHeaders } from './BaseClient';

export const InconsistencyCheckClient = (config: ClientConfig) => {
    const { accessToken, userRole, param = '' } = config;
    const headers = getHeaders(accessToken);
    const baseClientConfig = {
        useAdminRoute: userRole === Role.ADMIN && param !== '',
    };

    const getInconsistencyCheck = (period: Period): Promise<{ key: string; value: boolean }[]> => {
        const apiUrl = `${BaseClient(baseClientConfig).getApiUrl(Endpoints.INCONSISTENCYCHECK)}/${param}?quarter=${period.quarter}&year=${period.year}`;

        return fetchAndParse<{ key: string; value: boolean }[]>(apiUrl, {
            headers,
        });
    };

    return {
        getInconsistencyCheck,
    };
};
